/**
 * fastfive 시나리오 컨텍스트(선택 항목 + 사전질문 답변)의 브라우저 저장소.
 *
 * 만료는 여기서 판단하지 않는다. 서버가 대화를 돌려줬을 때만 되살리므로
 * (useLoadHistory 참고) 보관 기간은 계속 서버가 정한다.
 * 저장소가 막힌 환경에서는 조용히 no-op 이 되고, 복원된 대화에서 시나리오를
 * 역산하는 경로가 fallback 으로 받아준다.
 */

const storageKey = (partnerId) => `fastfive-context:${partnerId}`;

export const saveFastfiveContext = (partnerId, context) => {
    if (!partnerId || !context?.scenarioKey) return;
    try {
        localStorage.setItem(storageKey(partnerId), JSON.stringify(context));
    } catch (_) {
        // 저장소가 막혀 있으면 포기한다. 역산 fallback 이 받아준다.
    }
};

export const loadFastfiveContext = (partnerId) => {
    try {
        const raw = localStorage.getItem(storageKey(partnerId));
        return raw ? JSON.parse(raw) : null;
    } catch (_) {
        return null;
    }
};

/**
 * 저장된 컨텍스트에서 실제로 되살릴 값을 고른다.
 * 모르는 시나리오 키를 세팅하면 호출부의 역산 fallback 이 건너뛰어지고,
 * 사전답변은 그 답변을 받은 시나리오에서만 의미가 있다.
 */
export const resolveFastfiveRestore = (stored, scenarios, currentScenarioKey) => {
    const key = stored?.scenarioKey;
    const known = Array.isArray(scenarios) && scenarios.some((s) => s?.key === key);
    const active = currentScenarioKey || (known ? key : null);

    return {
        scenarioKey: currentScenarioKey ? null : active,
        preAnswersObject: key && key === active ? stored.preAnswersObject || null : null,
    };
};

export const clearFastfiveContext = (partnerId) => {
    try {
        localStorage.removeItem(storageKey(partnerId));
    } catch (_) {
        // no-op
    }
};
